import { useMutation } from "react-query";
import { API } from "../api";

export const useUpdateOrderStatus = () => useMutation(API.updateOrderStatus)